import * as styles from './index.module.scss';

import { useContext } from 'react';

import { SiteContext } from '@/contexts/site-context';
import { cleanHeadline, formatPhoneNumber, swapPhone } from '@/helpers/helpers';
import LocationLabel from '@/components/LocationLabel';
import { QueryParamElement } from '../QueryParamElement';

const defaultHeadline = 'Get Home Repair Help Fast!';
const defaultSubheadline = 'Get connected to a local pro right when you need one.';

const HeroCategoryCaseyDark = (props) => {
  const [site] = useContext(SiteContext);

  const headline = props.category?.headline || defaultHeadline;
  const subheadline = swapPhone(cleanHeadline(props.category?.subheadline, site.location) || defaultSubheadline, site.phone_number || props.category?.phone_number);

  return (
    <div className={styles['hero-category-container']}>
      <div className={`${styles['container']} container`}>
        <LocationLabel />
        <QueryParamElement className={site.location ? styles['has-location'] : ''} element="h1" queryParam="h1" fallbackText={headline} />
        <QueryParamElement element="h2" queryParam="h2" fallbackText={subheadline} injectFallback />
        <div className={styles['category-trigger-container']}>
          <a href={`tel:${site.phone_number}`} className={`button large ${styles['cta-trigger']} ${props.category?.use_caseys_theme_blue_button ? styles['dark'] : ''}`}>
            Call {formatPhoneNumber(site.phone_number)}
          </a>
        </div>
        <div className={styles['bullets-container']}>
          <div className={styles['bullet-container']}>
            <h4>Quick</h4>
            <label>Service</label>
          </div>
          <div className={styles['bullet-container']}>
            <h4>Trusted</h4>
            <label>Experts</label>
          </div>
          <div className={styles['bullet-container']}>
            <h4>Flexible</h4>
            <label>Appointments</label>
          </div>
          <div className={styles['bullet-container']}>
            <h4>24-Hours</h4>
            <label>Open 7 Days</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroCategoryCaseyDark;
